import {SnackbarKind, SnackbarSolo} from './types';
import {ThemeColorName, ThemeRadiusName} from '../../theme';

export const SnackbarStyleMap: {
  [key in SnackbarKind]: {
    [key in SnackbarSolo]: {
      backgroundColor: ThemeColorName;
      borderRadius?: ThemeRadiusName;
      raised?: boolean;
    };
  };
} = {
  Default: {
    No: {
      backgroundColor: 'background_mono_inverse_primary',
      raised: false,
    },
    Yes: {
      backgroundColor: 'background_mono_inverse_primary',
      borderRadius: '4',
      raised: true,
    },
  },
  Success: {
    No: {backgroundColor: 'background_positive_default', raised: false},
    Yes: {
      backgroundColor: 'background_positive_default',
      borderRadius: '4',
      raised: true,
    },
  },
  Error: {
    No: {backgroundColor: 'background_negative_default', raised: false},
    Yes: {
      backgroundColor: 'background_negative_default',
      borderRadius: '4',
      raised: false,
    },
  },
};
